import React from 'react';

export const BannerTemplatesTitle = ({ record }) => {
  return <span>Consent banner "{record.name}"</span>;
};
